export enum InternalTransferRequestStatus {
    STATUS_NEW = 1,
    STATUS_COMPLETED = 2,
    STATUS_CANCELED = 3,
}